module.exports = __webpack_public_path__ + "img/kxsjb.4ae2a3b.png";